import Service from "./Service";
import Student from "./Student";

const Update = {
  Service,
  Student,
};

export default Update;
